<template>
  <div class="user-form">
    <img class="logo" alt="ADRAYN" :src="$ComDomain.base + 'static/images/logo.png'">
    <h1><span>{{copyright.title}} &#8226; {{actions.reg}}</span></h1>
    <Form @submit.native.prevent>
      <div class="form-group">
        <span :class="{'input-group-addon':1, 'text-primary':mobileFocus}" @click="mobileFocus=1"><Icon type="md-phone-portrait"></Icon> {{userform.field.mobile}}</span>
        <Poptip v-model="mobileError" :content="warn.mobile" placement="bottom">
          <input @keyup.enter="passwordFocus=1" @input="mobileError=false" v-focus="mobileFocus" @focus="mobileFocus=1" @blur="mobileFocus=0" v-model="user.mobile" :placeholder="values.must" style="padding-left:75px" type="text" autocomplete="off" class="form-control" />
        </Poptip>
      </div>
      <div class="form-group">
        <span :class="{'input-group-addon':1, 'text-primary':passwordFocus}" @click="passwordFocus=1"><Icon type="md-lock"></Icon> {{userform.field.password}}</span>
        <Poptip v-model="passwordError" :content="warn.password" placement="bottom">
          <input @keyup.enter="password2Focus=1" @input="passwordError=false" v-focus="passwordFocus" @focus="passwordFocus=1" @blur="passwordFocus=0" v-model="user.password" :placeholder="userform.hint.password.format.replace('%', '')" maxlength="16" style="padding-left:62px" type="password" autocomplete="off" class="form-control">
        </Poptip>
      </div>
      <password-intensity :password="user.password"></password-intensity>
      <div class="form-group">
        <span :class="{'input-group-addon':1, 'text-primary':password2Focus}" @click="password2Focus=1"><Icon type="ios-lock-outline"></Icon> {{userform.field.confirmPwd}}</span>
        <Poptip v-model="password2Error" :content="warn.password2" placement="bottom">
          <input @keyup.enter="emailFocus=1" @input="password2Error=false" v-focus="password2Focus" @focus="password2Focus=1" @blur="password2Focus=0" v-model="user.password2" :placeholder="userform.hint.password.format.replace('%', '')" maxlength="16" style="padding-left:90px" type="password" autocomplete="off" class="form-control">
        </Poptip>
      </div>
      <div class="form-group">
        <span :class="{'input-group-addon':1, 'text-primary':emailFocus}" @click="emailFocus=1"><Icon type="md-mail"></Icon> {{userform.field.email}}</span>
        <Poptip v-model="emailError" :content="warn.email" placement="bottom">
          <input @keyup.enter="codeFocus=1" @input="emailError=false" v-focus="emailFocus" @focus="emailFocus=1" @blur="emailFocus=0" v-model="user.email" :placeholder="userform.hint.email" style="padding-left:65px" type="text" autocomplete="off" class="form-control">
        </Poptip>
      </div>
      <code-getter v-focus="codeFocus" @focus="codeFocus=1" @blur="codeFocus=0" process="reg" ref="CodeGetter" :user="user" :mobileError="mobileError" @done="doReg" @validate="validateMobile"></code-getter>
      <div class="form-group">
        <Button type="success" @click="doReg" shape="circle">{{ actions.reg }}</Button>
      </div>
    </Form>
    <div style="text-align:center;margin-top:-4px">
      <a role="button" @click="$store.commit('userEnter', {action: 'login'})">{{actions.loging}}</a>
    </div>
  </div>
</template>
<script>
import { Icon, Button, Form } from 'iview'
import { copyright, userform, actions, values, message } from '../../locale'
import { validatePhone, validatePassword, verify, vFocus } from '../../utils'
import PasswordIntensity from './PasswordIntensity'
import CodeGetter from '../CodeGetter'
import Poptip from './Poptip'

export default {
  name: 'Reg',
  data() {
    return {
      copyright,
      actions,
      userform,
      values,
      mobileError: false,
      mobileFocus: false,
      passwordError: false,
      passwordFocus: false,
      password2Error: false,
      password2Focus: false,
      emailError: false,
      emailFocus: false,
      codeFocus: 0,
      intensity: 'none',
      warn: {
        mobile: '',
        password: '',
        password2: '',
        email: ''
      },
      user: {
        mobile: '',
        password: '',
        password2: '',
        email: '',
        ic: ''
      }
    }
  },
  directives: {
    focus: vFocus
  },
  watch: {
    $route(to, from) {
      this.mobileError = this.passwordError = this.password2Error = this.emailError = false
    }
  },
  components: {
    Icon,
    Button,
    Form,
    PasswordIntensity,
    CodeGetter,
    Poptip
  },
  methods: {
    validateMobile() {
      let result = validatePhone(this.user.mobile)
      this.user.mobile = result.correct
      this.warn.mobile = result.text
      this.mobileFocus = this.mobileError = result.error
      if (!result.error) return true
    },
    doReg() {
      if (!this.validateMobile()) {
        return
      }
      let result = validatePassword(this.user.password, this.user.password2)
      this.warn.password = result.text
      this.warn.password2 = result.text2
      this.passwordFocus = this.passwordError = result.error
      this.password2Focus = this.password2Error = result.error2
      if (result.error || result.error2) return
      if (this.user.email) {
        this.emailFocus = this.emailError = !verify.verify(this.user.email, 'email')
        if (this.emailError) {
          this.warn.email = message.content.disformat.replace('%', userform.field.email)
          return
        }
      }
      this.$refs.CodeGetter.$emit('validate-then', () => {
        global.$ComAxios.post(this.$ComDomain.User.register, this.user)
          .then(response => {
            if (response.status == 200 && response.data.status == 200) {
              this.$store.dispatch('login', response.data).then(() => {
                if (this.$route.params.to) {
                  this.$router.push(this.$route.params.to)
                }
              })
            } else {
              this.$Message.error(response.data.msg)
            }
          })
      })
    }
  }
}

</script>
<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/commons/components/login/Reg.vue